import type { RouteRecordRaw } from 'vue-router';

import SettingsRouteName from './SettingsRouteName';

const PublicApiSettings = async () => import('@/features/settings/public-api-settings/PublicApiSettings.vue');
const ClickApiSettings = async () => import('@/features/settings/click-api-settings/ClickApiSettings.vue');
const ColumnsSettings = async () => import('@/features/settings/columns-settings/ColumnsSettings.vue');
const ImportExportSettings = async () => import('@/features/settings/import-export-settings/ImportExportSettings.vue');
const LandingPageProtectSettings = async () =>
  import('@/features/settings/landing-page-protect-settings/LandingPageProtectSettings.vue');
const IntegrationSettings = async () => import('@/features/settings/integration-settings/IntegrationSettings.vue');
const MainStatsSettings = async () => import('@/features/settings/main-stats-settings/MainStatsSettings.vue');
const PostbackProcessingSettings = async () =>
  import('@/features/settings/postback-processing-settings/PostbackProcessingSettings.vue');
const TrackingLinksSettings = async () =>
  import('@/features/settings/tracking-links-settings/TrackingLinksSettings.vue');
const UrlCustomizationSettings = async () =>
  import('@/features/settings/url-customization-settings/UrlCustomizationSettings.vue');
const UserSettings = async () => import('@/features/settings/user-settings/UserSettings.vue');
const AutoClearingsSettings = async () =>
  import('@/features/settings/auto-clearings-settings/AutoClearingsSettings.vue');
const FacebookSettings = async () => import('@/features/settings/facebook-settings/FacebookSettings.vue');
const FeedbackSettings = async () => import('@/features/settings/feedback-settings/FeedbackSettings.vue');
const UiSettings = async () => import('@/features/settings/ui-settings/UiSettings.vue');

const SettingsPage = async () => import('@/pages/settings/SettingsPage.vue');

export default function getSettingsRoutes(): RouteRecordRaw[] {
  return [
    {
      name: SettingsRouteName.SETTINGS,
      children: [
        {
          name: SettingsRouteName.TRACKING_LINKS_SETTINGS,
          component: TrackingLinksSettings,
          meta: {
            title: 'Tracking links - Settings',
          },
          path: 'tracking-links',
        },
        {
          name: SettingsRouteName.AUTO_CLEARING,
          component: AutoClearingsSettings,
          meta: {
            title: 'Auto clearings clicks',
          },
          path: 'auto-clearing',
        },
        {
          name: SettingsRouteName.USER_SETTINGS,
          component: UserSettings,
          meta: {
            title: 'User - Settings',
          },
          path: 'user',
        },
        {
          name: SettingsRouteName.UI_SETTINGS,
          component: UiSettings,
          meta: {
            title: 'User Interface - Settings',
          },
          path: 'ui',
        },
        {
          name: SettingsRouteName.STATS_SETTINGS,
          component: MainStatsSettings,
          meta: {
            title: 'Stats - Settings',
          },
          path: 'stats',
        },
        {
          name: SettingsRouteName.COLUMNS_SETTINGS,
          component: ColumnsSettings,
          meta: {
            title: 'Columns - Settings',
          },
          path: 'columns',
        },
        {
          name: SettingsRouteName.PUBLIC_API_SETTINGS,
          component: PublicApiSettings,
          meta: {
            title: 'Public API - Settings',
          },
          path: 'public-api',
        },
        {
          name: SettingsRouteName.CLICK_API_SETTINGS,
          component: ClickApiSettings,
          meta: {
            title: 'Click API - Settings',
          },
          path: 'click-api',
        },
        {
          name: SettingsRouteName.LANDING_PAGE_PROTECT_SETTINGS,
          component: LandingPageProtectSettings,
          meta: {
            title: 'LP protect - Settings',
          },
          path: 'lp-protect',
        },
        {
          name: SettingsRouteName.INTEGRATION,
          component: IntegrationSettings,
          meta: {
            title: 'Integration - Settings',
          },
          path: 'integration',
        },
        {
          name: SettingsRouteName.POSTBACK_PROCESSING_SETTINGS,
          component: PostbackProcessingSettings,
          meta: {
            title: 'Postback processing - Settings',
          },
          path: 'postback-processing',
        },
        {
          name: SettingsRouteName.IMPORT_EXPORT_SETTINGS,
          component: ImportExportSettings,
          meta: {
            title: 'Import/Export - Settings',
          },
          path: 'import-export',
        },
        {
          name: SettingsRouteName.URL_CUSTOMIZATION_SETTINGS,
          component: UrlCustomizationSettings,
          meta: {
            title: 'URL customization - Settings',
          },
          path: 'url-customization',
        },
        {
          name: SettingsRouteName.FACEBOOK_SETTINGS,
          component: FacebookSettings,
          meta: {
            title: 'Facebook - Settings',
          },
          path: 'facebook',
        },
        {
          name: SettingsRouteName.FEEDBACK_SETTINGS,
          component: FeedbackSettings,
          meta: {
            title: 'Feedback - Settings',
          },
          path: 'feedback',
        },
      ],
      component: SettingsPage,
      meta: {
        title: 'Settings',
        useIn: ['menu'],
      },
      path: '/settings',
      redirect: {
        name: SettingsRouteName.TRACKING_LINKS_SETTINGS,
      },
    },
  ];
}
